import React from 'react'

import { owners } from '../../core/controllers/Owners';

export default class OwnersSelect extends React.Component {
    constructor(props) {
        super(props);

        var colSize = 2;
        var title = "Select a owner";
        var sortID = "0";
        var styles;

        if(this.props.columnSize !== undefined)
        {
            colSize = this.props.columnSize;
        } 
        if(this.props.title !== undefined) 
        {
            title = this.props.title;
        } 
        if(this.props.sortID !== undefined || this.props.sortID != "") 
        {
            sortID = this.props.sortID;
        } 
        if(this.props.padding !== undefined) 
        {
            styles = {
                padding: this.props.padding
            }
        }

        this.options = {
            columnSize: "col-sm-" + colSize,
            title: title,
            sortID: sortID,
            styles: styles
        }

        if (colSize == 0) {
            this.options.columnSize = '';
        }

        this.state = {
            owners: []
        };
    }

    componentDidMount() {
        var self = this;
        owners.getOwners(function(response) {
            self.setState({owners: response.data})
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined || nextProps.sortID == "") {
            this.options.sortID = "0";
        } else {
            this.options.sortID = nextProps.sortID;
        }
    }

    render(){
        var disabled = false;
        if(this.props.disabled != undefined && this.props.disabled == true) {
            disabled = true;
        }
        const options = this.options;
        const owners = this.state.owners;
        return (
            <div class={options.columnSize} style={options.styles}>
                <small>{options.title}</small>
                <select disabled={disabled} readOnly={disabled} class="form-control" value={options.sortID} onChange={this.props.onChange}>
                    <option value="0">Select an owner</option>
                    { owners.map((owner, i) => {
                        return (
                            <option key={i} value={owner.owner.owner_id}>{owner.owner.name} - {owner.owner.company_name}</option>
                        )
                    })}
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/helpers/Owner/OwnersSelect.jsx